module.exports = __webpack_public_path__ + "img/truck.981960e1.jpg";